// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2hUyl","right":"styles_right__2Rerd"};